import { render } from "./RecuperarClave.vue?vue&type=template&id=997f4304"
import script from "./RecuperarClave.vue?vue&type=script&lang=js"
export * from "./RecuperarClave.vue?vue&type=script&lang=js"

import "./RecuperarClave.vue?vue&type=style&index=0&id=997f4304&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__